/* global gtag */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function lazyLoad(view, folder = null) {
  if (folder) {
    return () => import(`@/${folder}/${view}.vue`)
  }
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'IndexPage',
        component: lazyLoad("App/Index"),
      },
    ]
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: lazyLoad("App/Search"),
  },
  {
    path: '/about',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'AboutUs',
        component: lazyLoad("App/About"),
      },
    ]
  },
  {
    path: '/investors',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'InvestorsPage',
        component: lazyLoad("App/InvestorsPage"),
      },
    ]
  },
  {
    path: '/privacy-policy',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'PrivacyPolicyPage',
        component: lazyLoad("App/PrivacyPolicy"),
      },
    ]
  },
  {
    path: '/register',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'RegisterPage',
        component: lazyLoad("App/Register"),
      },
    ]
  },
  {
    path: '/news',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'NewsPage',
        component: lazyLoad("App/News"),
      },
    ]
  },
  {
    path: '/videos',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'VideosPage',
        component: lazyLoad("App/Videos"),
      },
      {
        path: 'search',
        name: 'VideosSearch',
        component: lazyLoad("App/VideosSearch"),
      },
    ]
  },
  {
    path: '/company',
    redirect: "/"
  },
  {
    path: '/company/:c_code',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'CompanyInformation',
        component: lazyLoad("App/Company"),
      },
    ]
  },
  {
    path: '/jobseeker',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: '',
        name: 'JobSeekerIndex',
        component: lazyLoad("JobSeekerIndex", "components/JobsBoard"),
      },
      {
        path: 'signup',
        name: 'JobSeekerSignup',
        component: lazyLoad("JobSeekerSignup", "components/JobsBoard"),
      },
      {
        path: 'login',
        name: 'JobSeekerLogin',
        component: lazyLoad("JobSeekerLogin", "components/JobsBoard"),
      },
      {
        path: 'profile',
        name: 'JobSeekerProfile',
        component: lazyLoad("JobSeekerProfile", "components/JobsBoard"),
      },
      {
        path: 'success/:id',
        name: 'PaymentSuccess',
        component: lazyLoad("PaymentSuccess", "components/JobsBoard"),
      },
      {
        path: 'success-upgrade/:id',
        name: 'PaymentSuccessUpgradeAccount',
        component: lazyLoad("SuccessUpgradeAccountUser", "components/JobsBoard"),
      },
      {
        path: 'terms-of-service',
        name: 'JobSeekerTermsOfService',
        component: lazyLoad("TermsOfService", "components/JobsBoard"),
      },
      {
        path: 'cancel-upgrade',
        redirect: "/jobseeker/profile",
      }
    ]
  },
  {
    path: '/employer',
    component: lazyLoad("App/Base"),
    children: [
      {
        path: 'signup',
        name: 'EmployerSignup',
        component: lazyLoad("EmployerSignup", "components/JobsBoard"),
      },
      {
        path: 'login',
        name: 'EmployerLogin',
        component: lazyLoad("EmployerLogin", "components/JobsBoard"),
      },
      {
        path: 'profile',
        name: 'EmployerProfile',
        component: lazyLoad("EmployerProfile", "components/JobsBoard"),
      },
      {
        path: 'success/:id',
        name: 'PaymentSuccessEmployer',
        component: lazyLoad("PaymentSuccessEmployer", "components/JobsBoard"),
      },
      {
        path: 'success-upgrade/:id',
        name: 'PaymentSuccessUpgradeAccountEmployer',
        component: lazyLoad("SuccessUpgradeAccountEmployer", "components/JobsBoard"),
      },
      {
        path: 'cancel-upgrade',
        redirect: "/employer/profile",
      }
    ]
  },
  {
    path: '/set_password',
    name: 'SetPassword',
    component: lazyLoad("App/SetPassword")
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
})

router.afterEach((to) => {
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', {
      page_path: to.fullPath,
      page_location: window.location.href,
      page_title: document.title
    });
  }
});

export default router